import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { KendoModule } from '../shared/kendo.module';
import { EditMessageModalForNewJobOfferPageRoutingModule } from './edit-message-modal-for-new-job-offer-page-routing.module';
import { EditMessageModalForNewJobOfferPage } from './edit-message-modal-for-new-job-offer-page.page';



@NgModule({
  declarations: [EditMessageModalForNewJobOfferPage],
  imports: [
    CommonModule,
    FormsModule,
    KendoModule,
    IonicModule,
    EditMessageModalForNewJobOfferPageRoutingModule
  ]
})
export class EditMessageModalForNewJobOfferModule { }
